var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.00003,
    y: 4,
    width: 18,
    height: 1.63636,
    rx: 0.818182,
    fill: "#3A3C45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 8.90918,
    width: 18,
    height: 1.63636,
    rx: 0.818182,
    fill: "#3A3C45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 13.8182,
    width: 18,
    height: 1.63636,
    rx: 0.818182,
    fill: "#3A3C45"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00006,
    y: 18.7274,
    width: 18,
    height: 1.63636,
    rx: 0.818182,
    fill: "#3A3C45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListing);
export default __webpack_public_path__ + "static/media/icon-listing.0580f4472a91253480c2464bb593a8c4.svg";
export { ForwardRef as ReactComponent };